export interface IEmployeeRole {
  employeeId: number;
  name: string;
  position: string;
  role: string;
  status: EmployeeStatuses;
  isEditItem?: boolean;
  dateOfDeleting?: string;
  requestInApproving: boolean;
  previousRole: string;
}

export interface IRole {
  name: string;
  id: number;
}

export enum EmployeeStatuses {
  Former = 'Former',
  Current = 'Current',
  Pending = 'Pending',
}

export interface IRoleChange {
  oldRole: string;
  newRole: string;
  name: string;
}
